import { ErpDiv, ErpH3, ErpP } from './ErpHtml';
import { iconFor } from '@/lib/iconRegistry';
import React, { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

const _EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => {
  // iconFor returns null for an unknown key, so fall back to the inbox glyph
  // instead of silently rendering no icon at all.
  const resolvedIcon = iconFor(icon || 'inbox', 36) ?? iconFor('inbox', 36);
  return (
    <ErpDiv className="flex flex-col items-center justify-center p-12 text-center border-2 border-dashed border-border rounded-lg bg-muted/30 text-foreground">
      <ErpDiv className="flex items-center justify-center w-16 h-16 rounded-full bg-background shadow-sm mb-4">
         <ErpDiv className="text-3xl text-muted-foreground">{resolvedIcon}</ErpDiv>
      </ErpDiv>
      <ErpH3 className="text-lg font-semibold text-foreground">{title}</ErpH3>
      {description && <ErpP className="text-sm text-muted-foreground mt-2 max-w-md">{description}</ErpP>}
      {action && <ErpDiv className="mt-6">{action}</ErpDiv>}
    </ErpDiv>
  );
};

export const EmptyState = React.memo(_EmptyState);
